export const ListQueryKey = 'rollConfigs';
export const DetailQueryKey = 'rollConfig';
export const Urls = {
  selectUrl: '/rollReward/list',
  updateUrl: '/rollReward/update',
  deleteUrl: '/rollReward/delete',
  createUrl: '/rollReward/create',
  detailUrl: '/rollReward/detail'
};